var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import * as _ from 'lodash';
import * as PropTypes from 'prop-types';
import { createShorthandFactory, UIComponent, commonPropTypes, } from '../../lib';
import ItemLayout from '../ItemLayout/ItemLayout';
import { listItemBehavior } from '../../lib/accessibility';
/**
 * A list item contains a single piece of content within a list.
 */
var ListItem = /** @class */ (function (_super) {
    __extends(ListItem, _super);
    function ListItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.actionHandlers = {
            performClick: function (event) {
                _this.handleClick(event);
                event.preventDefault();
            },
        };
        _this.handleClick = function (e) {
            _.invoke(_this.props, 'onClick', e, _this.props);
        };
        return _this;
    }
    ListItem.prototype.renderComponent = function (_a) {
        var classes = _a.classes, accessibility = _a.accessibility, rest = _a.rest, styles = _a.styles;
        var _b = this.props, as = _b.as, debug = _b.debug, endMedia = _b.endMedia, media = _b.media, content = _b.content, contentMedia = _b.contentMedia, header = _b.header, headerMedia = _b.headerMedia, truncateContent = _b.truncateContent, truncateHeader = _b.truncateHeader;
        return (React.createElement(ItemLayout, __assign({ as: as, className: classes.root, rootCSS: styles.root, content: content, contentMedia: contentMedia, debug: debug, endMedia: endMedia, header: header, headerMedia: headerMedia, media: media, mediaCSS: styles.media, truncateContent: truncateContent, truncateHeader: truncateHeader, headerCSS: styles.header, headerMediaCSS: styles.headerMedia, contentCSS: styles.content, onClick: this.handleClick }, accessibility.attributes.root, accessibility.keyHandlers.root, rest)));
    };
    ListItem.displayName = 'ListItem';
    ListItem.className = 'ui-list__item';
    ListItem.propTypes = __assign({}, commonPropTypes.createCommon({
        children: false,
        content: false,
    }), { contentMedia: PropTypes.any, content: PropTypes.any, debug: PropTypes.bool, header: PropTypes.any, endMedia: PropTypes.any, headerMedia: PropTypes.any, important: PropTypes.bool, media: PropTypes.any, selectable: PropTypes.bool, selected: PropTypes.bool, truncateContent: PropTypes.bool, truncateHeader: PropTypes.bool, accessibility: PropTypes.func, onClick: PropTypes.func });
    ListItem.defaultProps = {
        as: 'li',
        accessibility: listItemBehavior,
    };
    return ListItem;
}(UIComponent));
ListItem.create = createShorthandFactory(ListItem, 'content');
export default ListItem;
